// ─── DirectionPicker.js ───────────────────────────────────────────────────────
// Compact compass rose for tagging photo direction (aspect the camera faces).
// The building aspect is the OPPOSITE direction.

import React, { useState } from 'react';

const DIRECTIONS = [
  { id: 'N',  label: 'N',  full: 'North',      angle: 0 },
  { id: 'NE', label: 'NE', full: 'North East',  angle: 45 },
  { id: 'E',  label: 'E',  full: 'East',        angle: 90 },
  { id: 'SE', label: 'SE', full: 'South East',   angle: 135 },
  { id: 'S',  label: 'S',  full: 'South',       angle: 180 },
  { id: 'SW', label: 'SW', full: 'South West',   angle: 225 },
  { id: 'W',  label: 'W',  full: 'West',        angle: 270 },
  { id: 'NW', label: 'NW', full: 'North West',   angle: 315 },
];

// Opposite direction lookup (camera faces N → aspect is S)
const OPPOSITE = { N:'S', NE:'SW', E:'W', SE:'NW', S:'N', SW:'NE', W:'E', NW:'SE' };

export function headingToDirection(heading) {
  if (heading == null || heading < 0) return null;
  const dirs = ['N','NE','E','SE','S','SW','W','NW'];
  const idx = Math.round(heading / 45) % 8;
  return dirs[idx];
}

export function cameraToAspect(cameraDir) {
  return OPPOSITE[cameraDir] || cameraDir;
}

export function aspectLabel(aspect) {
  if (!aspect) return null;
  const d = DIRECTIONS.find(x => x.id === aspect);
  return d ? `${d.full} Aspect` : `${aspect} Aspect`;
}

export function directionBadge(aspect) {
  if (!aspect) return null;
  return aspect;
}

export default function DirectionPicker({ value, onChange, compact }) {
  const [open, setOpen] = useState(false);

  if (!open) {
    return (
      <button className={`dp-trigger ${value ? 'dp-has-value' : ''}`} onClick={() => setOpen(true)} title="Set direction">
        🧭 {value || '—'}
      </button>
    );
  }

  return (
    <div className="dp-picker">
      <div className="dp-rose">
        {DIRECTIONS.map(d => (
          <button
            key={d.id}
            className={`dp-dir ${value === d.id ? 'active' : ''}`}
            style={{ '--angle': `${d.angle}deg` }}
            onClick={() => { onChange(d.id); setOpen(false); }}
            title={`Camera facing ${d.full}`}
          >
            {d.label}
          </button>
        ))}
        <div className="dp-center">🧭</div>
      </div>
      {value && (
        <button className="dp-clear" onClick={() => { onChange(null); setOpen(false); }}>
          ✕ Clear
        </button>
      )}
      <button className="dp-close" onClick={() => setOpen(false)}>Done</button>
    </div>
  );
}

export { DIRECTIONS };
